console.log('flag-lang.js chargé ✅');

function initFlagSelector() {
  document.querySelectorAll('.flag-lang-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var dropdown = btn.nextElementSibling;
      var isHidden = dropdown.hasAttribute('hidden');
      dropdown.toggleAttribute('hidden', !isHidden);
      btn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.flag-lang-wrapper')) {
      document.querySelectorAll('.flag-lang-dropdown').forEach(function(d) {
        d.setAttribute('hidden', '');
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFlagSelector);
} else {
  initFlagSelector();
}
